const OPERATORS = [
  { symbol: "+", label: "جمع" },
  { symbol: "-", label: "تفریق" },
  { symbol: "*", label: "ضرب" },
  { symbol: "/", label: "تقسیم" },
  { symbol: "(", label: "پرانتز باز" },
  { symbol: ")", label: "پرانتز بسته" },
  { symbol: ",", label: "جداکننده آرگومان" },
];

const COMPARISONS = [
  { symbol: ">=", label: "بزرگتر یا مساوی" },
  { symbol: "<=", label: "کوچکتر یا مساوی" },
  { symbol: ">", label: "بزرگتر" },
  { symbol: "<", label: "کوچکتر" },
  { symbol: "==", label: "مساوی" },
  { symbol: "!=", label: "نامساوی" },
];

const FUNCTIONS = [
  { symbol: "AVG", label: "میانگین (از پیش محاسبه شده در متغیرها)" },
  { symbol: "SUM", label: "جمع" },
  { symbol: "MAX", label: "بیشینه" },
  { symbol: "MIN", label: "کمینه" },
  { symbol: "ROUND", label: "گرد کردن" },
  { symbol: "IF", label: "شرط IF(شرط, اگر درست, اگر غلط)" },
  { symbol: "AND", label: "و منطقی" },
  { symbol: "OR", label: "یا منطقی" },
  { symbol: "NOT", label: "نقیض" },
  { symbol: "LOOKUP_BAND", label: "جستجوی باند LOOKUP_BAND(x, TABLES.key)" },
];

const METRIC_UNITS = [
  { value: "carton", label: "کارتن (net_pack_qty)" },
  { value: "qty", label: "ظرف (net_pack_qty)" },
  { value: "weight", label: "تناژ (net_weight_kg)" },
  { value: "amount", label: "مبلغ (net_amount)" },
];

const OUTPUT_KEYS = [
  {
    key: "sale_target",
    fa: "تارگت فروش",
    en: "Sale Target",
    defaultFormula:
      "supervisor_sale_target * (supervisor_avg_metric / seller_avg_metric)",
  },
  {
    key: "customer_target",
    fa: "تارگت مشتری",
    en: "Customer Target",
    defaultFormula:
      "supervisor_customer_target * (supervisor_avg_customer / seller_avg_customer)",
  },
];

const TARGET_FIELDS = [
  {
    key: "supervisor_sale_target",
    fa: "تارگت فروش سرپرست (همین محصول/ماه)",
    en: "Supervisor sale target",
    category: "تارگت",
  },
  {
    key: "supervisor_customer_target",
    fa: "تارگت مشتری سرپرست (همین محصول/ماه)",
    en: "Supervisor customer target",
    category: "تارگت",
  },
  {
    key: "seller_sale_target",
    fa: "تارگت فروش فروشنده",
    en: "Seller sale target",
    category: "تارگت",
  },
  {
    key: "seller_customer_target",
    fa: "تارگت مشتری فروشنده",
    en: "Seller customer target",
    category: "تارگت",
  },
  {
    key: "supervisor_avg_metric",
    fa: "میانگین معیار سرپرست (خودکار بر اساس واحد محصول)",
    en: "Supervisor avg metric (auto by product unit)",
    category: "میانگین N ماه",
  },
  {
    key: "seller_avg_metric",
    fa: "میانگین معیار فروشنده (خودکار بر اساس واحد محصول)",
    en: "Seller avg metric (auto by product unit)",
    category: "میانگین N ماه",
  },
  {
    key: "ratio_metric",
    fa: "نسبت معیار خودکار (سرپرست/فروشنده بر اساس واحد محصول)",
    en: "Auto metric ratio by product unit",
    category: "نسبت‌ها",
  },
  {
    key: "supervisor_avg_carton",
    fa: "میانگین کارتن سرپرست",
    en: "Supervisor avg carton",
    category: "میانگین N ماه",
  },
  {
    key: "seller_avg_carton",
    fa: "میانگین کارتن فروشنده",
    en: "Seller avg carton",
    category: "میانگین N ماه",
  },
  {
    key: "supervisor_avg_qty",
    fa: "میانگین عدد سرپرست",
    en: "Supervisor avg qty",
    category: "میانگین N ماه",
  },
  {
    key: "seller_avg_qty",
    fa: "میانگین عدد فروشنده",
    en: "Seller avg qty",
    category: "میانگین N ماه",
  },
  {
    key: "supervisor_avg_weight",
    fa: "میانگین وزن سرپرست",
    en: "Supervisor avg weight",
    category: "میانگین N ماه",
  },
  {
    key: "seller_avg_weight",
    fa: "میانگین وزن فروشنده",
    en: "Seller avg weight",
    category: "میانگین N ماه",
  },
  {
    key: "supervisor_avg_customer",
    fa: "میانگین مشتری سرپرست",
    en: "Supervisor avg customer",
    category: "میانگین N ماه",
  },
  {
    key: "seller_avg_customer",
    fa: "میانگین مشتری فروشنده",
    en: "Seller avg customer",
    category: "میانگین N ماه",
  },
  {
    key: "ratio_customer",
    fa: "نسبت مشتری (سرپرست/فروشنده)",
    en: "Customer ratio",
    category: "نسبت‌ها",
  },
  {
    key: "ratio_carton",
    fa: "نسبت کارتن",
    en: "Carton ratio",
    category: "نسبت‌ها",
  },
  {
    key: "n_percent",
    fa: "درصد ضریب",
    en: "Percent multiplier",
    category: "پارامترها",
  },
  {
    key: "months_lookback",
    fa: "تعداد ماه میانگین",
    en: "Months lookback",
    category: "پارامترها",
  },
];

const DASHBOARD_FIELDS = [
  { key: "total_sales", fa: "کل فروش (همه گروه‌ها)", category: "داشبورد" },
  { key: "targeted_sales", fa: "فروش گروه‌های دارای تارگت", category: "داشبورد" },
  { key: "sale_target", fa: "تارگت فروش (جمع f_sale_target)", category: "داشبورد" },
  { key: "total_customers", fa: "کل مشتری", category: "داشبورد" },
  { key: "customer_count", fa: "مشتری فعال", category: "داشبورد" },
  { key: "customer_count_month", fa: "تعداد مشتری ماه", category: "داشبورد" },
  { key: "targeted_customers", fa: "مشتری گروه‌های دارای تارگت", category: "داشبورد" },
  { key: "customer_target", fa: "تارگت مشتری (جمع f_customer_target)", category: "داشبورد" },
  { key: "customer_target_month", fa: "هدف کل مشتری ماه", category: "داشبورد" },
  { key: "financial_claims", fa: "مطالبات مالی (profile)", category: "داشبورد" },
  { key: "total_net_amount", fa: "فروش خالص ریالی", category: "داشبورد" },
  { key: "net_pack_qty", fa: "کارتن خالص", category: "داشبورد" },
  { key: "net_qty", fa: "مقدار خالص / ظرف", category: "داشبورد" },
  { key: "net_weight_kg", fa: "وزن خالص (کیلوگرم)", category: "داشبورد" },
  { key: "net_weight_ton", fa: "وزن خالص تناژ (kg/1000)", category: "داشبورد" },
  { key: "total_gross_carton", fa: "کل کارتن ناخالص", category: "داشبورد" },
  { key: "total_net_carton", fa: "کل کارتن خالص", category: "داشبورد" },
  { key: "total_return_carton", fa: "کل کارتن مرجوعی", category: "داشبورد" },
  { key: "percent_return_carton", fa: "درصد کارتن مرجوعی", category: "داشبورد" },
  { key: "add_amount", fa: "مبلغ اضافات", category: "داشبورد" },
  { key: "gross_after_discount", fa: "ناخالص بعد از تخفیف", category: "داشبورد" },
  { key: "return_pack_qty", fa: "کارتن مرجوعی", category: "داشبورد" },
  { key: "sale_pct", fa: "درصد تحقق فروش", category: "داشبورد" },
  { key: "customer_pct", fa: "درصد تحقق مشتری", category: "داشبورد" },
  { key: "achievement_gap_sale", fa: "فاصله تا تارگت فروش", category: "داشبورد" },
  { key: "achievement_gap_customer", fa: "فاصله تا تارگت مشتری", category: "داشبورد" },
  { key: "f_sale_target", fa: "تارگت فروش برنامه", category: "داشبورد" },
  { key: "f_customer_target", fa: "تارگت مشتری برنامه", category: "داشبورد" },
  { key: "commission_paid", fa: "پورسانت پرداختی", category: "پورسانت" },
  { key: "commission_allocated", fa: "پورسانت مصوب", category: "پورسانت" },
  { key: "commission_sale", fa: "پورسانت تارگت فروش", category: "پورسانت" },
  { key: "commission_return", fa: "پورسانت مرجوعی", category: "پورسانت" },
  { key: "commission_active", fa: "پورسانت تارگت اکتیو مشتریان", category: "پورسانت" },
  { key: "commission_claims", fa: "پورسانت مطالبات", category: "پورسانت" },
  { key: "commission_entry_passed", fa: "شرط ورود پورسانت", category: "پورسانت" },
  { key: "commission_basket_achievement", fa: "درصد تحقق سبد حجمی", category: "پورسانت" },
];

const DEFAULT_FIELD_CATALOGS = {
  calculation_formula: TARGET_FIELDS,
  sales_summary_formula: TARGET_FIELDS,
  dashboard_formula: DASHBOARD_FIELDS,
};

const DASHBOARD_OUTPUT_KEYS = [
  {
    key: "sale_pct",
    fa: "درصد تحقق فروش",
    defaultFormula: "(total_sales / sale_target) * 100",
  },
  {
    key: "customer_pct",
    fa: "درصد تحقق مشتری",
    defaultFormula: "(total_customers / customer_target) * 100",
  },
];

const FORMULA_KINDS = [
  { value: "suggestion", label: "پیشنهاد تارگت" },
  { value: "commission", label: "محاسبه پورسانت" },
  { value: "job", label: "وظیفه / سفارشی" },
];

const RETURN_PACK_FORMULA =
  "(return_cause_vocher_pack_qty + return_cause_prize_vocher_pack_qty + return_cause_sell_return_pack_qty) / (return_cause_vocher_pack_qty + return_cause_prize_vocher_pack_qty + return_cause_sell_return_pack_qty + net_pack_qty) * 100";
const RETURN_GROSS_FORMULA =
  "(total_gross_carton - net_pack_qty) / total_gross_carton * 100";
const GROUP_BAND_COMMISSION_FORMULA =
  "group_allocated * (group_applied_capped / 100) + group_excess";
const GROUP_RIAL_CAP_FORMULA =
  "IF(AND(net_amount > 0, group_band_commission / net_amount * 100 > rial_cap_trigger_percent), net_amount * (rial_cap_percent / 100), group_band_commission)";

const QUERY_CATALOG = [
  {
    key: "volume_by_unit",
    fa: "تحقق حجمی بر اساس واحد گروه کالا",
    metric: "volume_target",
    formula: "(actual_quantity / sale_target) * 100",
    fields: [
      { key: "actual_quantity", fa: "مقدار واقعی (بر اساس واحد)", category: "کوئری حجم" },
      { key: "sale_target", fa: "تارگت فروش گروه", category: "کوئری حجم" },
      { key: "net_pack_qty", fa: "کارتن خالص", category: "کوئری حجم" },
      { key: "net_qty", fa: "ظرف خالص", category: "کوئری حجم" },
      { key: "net_weight_kg", fa: "وزن خالص (کیلو)", category: "کوئری حجم" },
      { key: "net_amount", fa: "فروش ریالی گروه", category: "کوئری حجم" },
    ],
  },
  {
    key: "return_percentage_gross_carton",
    fa: "درصد مرجوعی کارتن ناخالص (ناخالص − خالص) / ناخالص",
    metric: "return_pct",
    formula: RETURN_GROSS_FORMULA,
    fields: [
      { key: "total_gross_carton", fa: "کارتن ناخالص", category: "کوئری مرجوعی" },
      { key: "net_pack_qty", fa: "کارتن خالص", category: "کوئری مرجوعی" },
    ],
  },
  {
    key: "return_percentage_pack_qty",
    fa: "درصد مرجوعی کارتن (pack_qty)",
    metric: "return_pct",
    formula: RETURN_PACK_FORMULA,
    fields: [
      { key: "return_cause_vocher_pack_qty", fa: "مرجوعی کارتن (علت سند)", category: "کوئری مرجوعی" },
      { key: "return_cause_prize_vocher_pack_qty", fa: "مرجوعی کارتن جایزه", category: "کوئری مرجوعی" },
      { key: "return_cause_sell_return_pack_qty", fa: "مرجوعی کارتن فروش", category: "کوئری مرجوعی" },
      { key: "net_pack_qty", fa: "کارتن خالص", category: "کوئری مرجوعی" },
    ],
  },
  {
    key: "return_percentage_qty",
    fa: "درصد مرجوعی ظرف (qty)",
    metric: "return_pct",
    formula: "(return_qty / (return_qty + net_qty)) * 100",
    fields: [
      { key: "return_qty", fa: "مقدار مرجوعی", category: "کوئری مرجوعی" },
      { key: "net_qty", fa: "ظرف خالص", category: "کوئری مرجوعی" },
    ],
  },
  {
    key: "return_percentage_weight",
    fa: "درصد مرجوعی وزن (kg)",
    metric: "return_pct",
    formula: "(return_weight_kg / (return_weight_kg + net_weight_kg)) * 100",
    fields: [
      { key: "return_weight_kg", fa: "وزن مرجوعی", category: "کوئری مرجوعی" },
      { key: "net_weight_kg", fa: "وزن خالص", category: "کوئری مرجوعی" },
    ],
  },
  {
    key: "active_customer_target_month",
    fa: "تارگت اکتیو مشتریان (هدف مشتری ماهانه پروفایل)",
    metric: "active_target",
    formula: "(customer_count_month / customer_target_month) * 100",
    fields: [
      { key: "customer_count_month", fa: "مشتری فعال ماه", category: "کوئری اکتیو" },
      { key: "customer_target_month", fa: "تارگت اکتیو مشتریان", category: "کوئری اکتیو" },
    ],
  },
  {
    key: "claims_over_net_amount",
    fa: "مطالبات / فروش ریالی",
    metric: "claims",
    formula: "(financial_claims / net_amount) * 100",
    fields: [
      { key: "financial_claims", fa: "مطالبات مالی", category: "کوئری مطالبات" },
      { key: "net_amount", fa: "فروش ریالی", category: "کوئری مطالبات" },
    ],
  },
];

const COMMISSION_PARAM_FIELDS = [
  { key: "approved_amount", fa: "مبلغ مصوب پورسانت", category: "پارامترها" },
  { key: "sale_weight", fa: "وزن تارگت فروش (%)", category: "پارامترها" },
  { key: "component_weight", fa: "وزن شاخص (%)", category: "پارامترها" },
  { key: "basket_percent", fa: "درصد سبد گروه", category: "پارامترها" },
  { key: "excess_percent", fa: "درصد مازاد گروه", category: "پارامترها" },
  { key: "max_payout_percent", fa: "سقف درصد اعمالی (اختیاری)", category: "پارامترها" },
  { key: "rial_cap_trigger_percent", fa: "آستانه سقف ریالی (٪ از فروش)", category: "پارامترها" },
  { key: "rial_cap_percent", fa: "سقف ریالی پرداخت (٪ از فروش)", category: "پارامترها" },
  { key: "group_band_commission", fa: "پورسانت باند گروه", category: "گروه کالا" },
  { key: "entry_min_percent", fa: "حداقل شرط ورود", category: "شرط ورود" },
  { key: "basket_achievement", fa: "تحقق سبد (جمع وزن‌دار)", category: "شرط ورود" },
  { key: "entry_gated", fa: "شاخص مشمول شرط ورود (۰/۱)", category: "شرط ورود" },
  { key: "entry_passed", fa: "شرط ورود برقرار (۰/۱)", category: "شرط ورود" },
  { key: "achievement", fa: "درصد تحقق شاخص جاری", category: "شاخص پرسنل" },
  { key: "group_achievement", fa: "درصد تحقق گروه", category: "گروه کالا" },
  { key: "group_allocated", fa: "تخصیص گروه", category: "گروه کالا" },
  { key: "group_applied", fa: "درصد اعمالی گروه", category: "گروه کالا" },
  { key: "group_applied_capped", fa: "درصد اعمالی با سقف", category: "گروه کالا" },
  { key: "group_excess", fa: "مازاد گروه", category: "گروه کالا" },
  { key: "commission_sale", fa: "پورسانت فروش", category: "جمع" },
  { key: "commission_return", fa: "پورسانت مرجوعی", category: "جمع" },
  { key: "commission_active", fa: "پورسانت اکتیو", category: "جمع" },
  { key: "commission_claims", fa: "پورسانت مطالبات", category: "جمع" },
  { key: "TABLES", fa: "جداول باند (TABLES.volume_target)", category: "توابع" },
];

const COMMISSION_OUTPUT_KEYS = [
  { key: "group_achievement", fa: "درصد تحقق گروه", group: "گروه کالا", queryMetric: "volume_target", defaultFormula: "(actual_quantity / sale_target) * 100" },
  { key: "group_allocated", fa: "تخصیص ریالی گروه", group: "گروه کالا", defaultFormula: "approved_amount * (sale_weight / 100) * (basket_percent / 100)" },
  { key: "group_applied", fa: "درصد اعمالی باند حجمی", group: "گروه کالا", defaultFormula: "LOOKUP_BAND(group_achievement, TABLES.volume_target)" },
  { key: "group_applied_capped", fa: "درصد اعمالی پس از سقف اختیاری", group: "گروه کالا", defaultFormula: "group_applied" },
  { key: "group_excess", fa: "مازاد گروه", group: "گروه کالا", defaultFormula: "IF(AND(group_achievement > 100, excess_percent > 0), net_amount * (excess_percent / 100), 0)" },
  { key: "group_band_commission", fa: "پورسانت باند گروه (قبل از سقف ریالی)", group: "گروه کالا", defaultFormula: GROUP_BAND_COMMISSION_FORMULA },
  { key: "group_commission", fa: "پورسانت گروه پس از سقف ریالی", group: "گروه کالا", defaultFormula: GROUP_RIAL_CAP_FORMULA },
  { key: "basket_weight", fa: "سهم سبد گروه", group: "سبد", defaultFormula: "group_achievement * (basket_percent / 100)" },
  { key: "entry_passed", fa: "شرط ورود", group: "شرط ورود", defaultFormula: "IF(basket_achievement >= entry_min_percent, 1, 0)" },
  { key: "return_percent", fa: "درصد مرجوعی", group: "شاخص پرسنل", queryMetric: "return_pct", defaultFormula: RETURN_GROSS_FORMULA },
  { key: "active_percent", fa: "درصد تارگت اکتیو مشتریان", group: "شاخص پرسنل", queryMetric: "active_target", defaultFormula: "(customer_count_month / customer_target_month) * 100" },
  { key: "claims_percent", fa: "درصد مطالبات", group: "شاخص پرسنل", queryMetric: "claims", defaultFormula: "(financial_claims / net_amount) * 100" },
  { key: "component_allocated", fa: "تخصیص شاخص پرسنلی", group: "شاخص پرسنل", defaultFormula: "approved_amount * (component_weight / 100)" },
  { key: "component_applied", fa: "درصد اعمالی شاخص", group: "شاخص پرسنل", defaultFormula: "IF(AND(entry_gated, NOT(entry_passed)), 0, LOOKUP_BAND(achievement, TABLES.current))" },
  { key: "component_paid", fa: "پرداخت شاخص", group: "شاخص پرسنل", defaultFormula: "IF(AND(entry_gated, NOT(entry_passed)), 0, component_allocated * (component_applied / 100))" },
  { key: "commission_paid", fa: "پورسانت پرداختی کل", group: "جمع", defaultFormula: "commission_sale + commission_return + commission_active + commission_claims" },
];

const JOB_OUTPUT_KEYS = [
  { key: "result", fa: "نتیجه وظیفه", group: "وظیفه", defaultFormula: "" },
];

const COMMISSION_COMPONENT_QUERIES = [
  { tableKey: "volume_target", fa: "تارگت فروش / حجم", queryKeys: ["volume_by_unit"] },
  { tableKey: "active_target", fa: "تارگت اکتیو مشتریان", queryKeys: ["active_customer_target_month"] },
  { tableKey: "return_pct", fa: "درصد مرجوعی", queryKeys: ["return_percentage_gross_carton", "return_percentage_pack_qty", "return_percentage_qty", "return_percentage_weight"] },
  { tableKey: "claims", fa: "مطالبات", queryKeys: ["claims_over_net_amount"] },
];

function slugifyKey(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_\u0600-\u06FF-]/g, "")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");
}

function expressionToString(expression = []) {
  return expression
    .map((item) => {
      if (!item) return "";
      if (item.type === "function") return `${item.value}(`;
      return String(item.value);
    })
    .join(" ")
    .replace(/\(\s+/g, "(")
    .replace(/\s+\)/g, ")");
}

function parseFormulaString(formula = "") {
  if (!formula || typeof formula !== "string") return [];

  const tokens = formula
    .replace(/(>=|<=|==|!=|<>|[+\-*/()<>,])/g, " $1 ")
    .split(/\s+/)
    .filter(Boolean);

  const operatorSymbols = new Set([
    ...OPERATORS.map((op) => op.symbol),
    ...COMPARISONS.map((op) => op.symbol),
  ]);

  return tokens.map((token) => {
    if (operatorSymbols.has(token)) {
      return { type: "operator", value: token };
    }
    if (FUNCTIONS.some((fn) => fn.symbol === token.toUpperCase())) {
      return {
        type: "function",
        value: token.toUpperCase(),
        label: token.toUpperCase(),
      };
    }
    if (!Number.isNaN(Number(token)) && token.trim() !== "") {
      return { type: "number", value: Number(token) };
    }
    return {
      type: "field",
      value: token,
      label: token,
    };
  });
}

function readOutputFormula(value, fallback = "") {
  if (!value) return fallback;
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    return value.formula || value.expression_string || fallback;
  }
  return fallback;
}

function readOutputExpression(value, formulaFallback = "") {
  if (
    value &&
    typeof value === "object" &&
    Array.isArray(value.expression) &&
    value.expression.length > 0
  ) {
    return value.expression;
  }
  return parseFormulaString(readOutputFormula(value, formulaFallback));
}

function normalizeFormulaEntry(key, raw = {}, settingsKey = "") {
  const kind = inferKind(settingsKey, raw);
  const outputDefs = getOutputDefinitions(settingsKey, kind);

  const outputs = {};
  const expressions = {};

  outputDefs.forEach((def) => {
    const fromOutputs = raw.outputs?.[def.key];
    const legacySingle =
      def.key === "sale_target" ? raw.formula || "" : raw[`${def.key}_formula`] || "";
    const formula = readOutputFormula(fromOutputs, legacySingle || def.defaultFormula || "");
    outputs[def.key] = formula;
    expressions[def.key] = readOutputExpression(fromOutputs, formula);
  });

  Object.entries(raw.outputs || {}).forEach(([outKey, value]) => {
    if (outputs[outKey] != null) return;
    const formula = readOutputFormula(value, "");
    outputs[outKey] = formula;
    expressions[outKey] = readOutputExpression(value, formula);
  });

  const primaryKey = outputDefs[0]?.key;
  const primaryFormula = (primaryKey && outputs[primaryKey]) || raw.formula || "";
  const primaryExpression =
    (primaryKey && expressions[primaryKey]?.length > 0)
      ? expressions[primaryKey]
      : parseFormulaString(primaryFormula);

  return {
    key,
    title: raw.title || raw.fa_description || raw.description || key,
    description: raw.description || "",
    fa_description: raw.fa_description || raw.title || "",
    kind,
    formula: primaryFormula,
    expression: primaryExpression,
    outputs,
    expressions,
    formula_type: raw.formula_type || key,
    months_lookback: raw.months_lookback ?? 3,
    metric_unit: raw.metric_unit || "carton",
    fields: raw.fields || {},
    queries: raw.queries || {},
    tables: raw.tables || {},
    entry_condition: raw.entry_condition || {},
    query_key: raw.query_key || "",
    rial_cap_trigger_percent: raw.rial_cap_trigger_percent
      ?? raw.fields?.rial_cap_trigger_percent
      ?? 2.2,
    rial_cap_percent: raw.rial_cap_percent
      ?? raw.fields?.rial_cap_percent
      ?? 2,
  };
}

export function normalizeFormulaConfig(settingsJson = {}, settingsKey = "") {
  const notes = settingsJson.notes || "";
  const formulasMap = {};

  if (settingsJson.formulas && typeof settingsJson.formulas === "object") {
    Object.entries(settingsJson.formulas).forEach(([key, value]) => {
      formulasMap[key] = normalizeFormulaEntry(key, value, settingsKey);
    });
  }

  if (settingsJson.suggestion_formula) {
    formulasMap.suggestion_formula = normalizeFormulaEntry(
      "suggestion_formula",
      settingsJson.suggestion_formula,
      settingsKey,
    );
  }

  if (
    settingsJson.alternative_formulas &&
    typeof settingsJson.alternative_formulas === "object"
  ) {
    Object.entries(settingsJson.alternative_formulas).forEach(([key, value]) => {
      formulasMap[key] = normalizeFormulaEntry(key, value, settingsKey);
    });
  }

  const formulas = Object.values(formulasMap);
  const activeFormula =
    settingsJson.active_formula || (formulas[0] ? formulas[0].key : "");

  return {
    notes,
    active_formula: activeFormula,
    formulas,
  };
}

export function denormalizeFormulaConfig(model, options = {}) {
  const { preserveLegacy = true, settingsKey = "" } = options;
  const isDashboard = settingsKey === "dashboard_formula";
  const formulas = {};

  (model.formulas || []).forEach((item) => {
    const key = item.key;
    const kind = item.kind || inferKind(settingsKey, item);
    const outputDefs = getOutputDefinitions(settingsKey, kind);
    const outputs = {};

    const keys = new Set([
      ...outputDefs.map((def) => def.key),
      ...Object.keys(item.outputs || {}),
    ]);

    keys.forEach((outKey) => {
      const def = outputDefs.find((d) => d.key === outKey);
      const formula =
        item.outputs?.[outKey] ||
        (outKey === "sale_target" ? item.formula : "") ||
        "";
      const expression =
        item.expressions?.[outKey] ||
        (outKey === "sale_target" ? item.expression : []) ||
        parseFormulaString(formula);

      outputs[outKey] = {
        formula: formula || expressionToString(expression),
        expression,
      };
      if (def) outputs[outKey].fa = def.fa;
    });

    const primary = outputs[outputDefs[0]?.key] || { formula: "", expression: [] };

    formulas[key] = {
      title: item.title || key,
      description: item.description || "",
      fa_description: item.fa_description || item.title || "",
      kind,
      formula: primary.formula,
      expression: primary.expression,
      outputs,
      formula_type: item.formula_type || key,
      months_lookback: Number(item.months_lookback) || 3,
      metric_unit: item.metric_unit || "carton",
      queries: item.queries || {},
      tables: item.tables || {},
      entry_condition: item.entry_condition || {},
      query_key: item.query_key || "",
      rial_cap_trigger_percent: item.rial_cap_trigger_percent ?? item.fields?.rial_cap_trigger_percent ?? 2.2,
      rial_cap_percent: item.rial_cap_percent ?? item.fields?.rial_cap_percent ?? 2,
      fields: {
        ...(item.fields || {}),
        rial_cap_trigger_percent: item.rial_cap_trigger_percent ?? item.fields?.rial_cap_trigger_percent ?? 2.2,
        rial_cap_percent: item.rial_cap_percent ?? item.fields?.rial_cap_percent ?? 2,
      },
    };
  });

  const result = {
    notes: model.notes || "",
    active_formula: model.active_formula || Object.keys(formulas)[0] || "",
    formulas,
  };

  if (preserveLegacy && !isDashboard && settingsKey !== "commission_calc_formula") {
    if (formulas.suggestion_formula) {
      result.suggestion_formula = formulas.suggestion_formula;
    }
    const alternatives = { ...formulas };
    delete alternatives.suggestion_formula;
    result.alternative_formulas = alternatives;
  }

  return result;
}

export function getFormulaFieldCatalog(setting, options = {}) {
  const schemaFields = setting?.settings_schema?.fields;
  if (Array.isArray(schemaFields) && schemaFields.length > 0 && !options.ignoreSchema) {
    return schemaFields.map((field) => ({
      key: field.key,
      fa: field.fa || field.en || field.key,
      en: field.en || field.key,
      category: field.category || "فیلدها",
      source: field.source,
      description: field.description,
    }));
  }

  const settingsKey = setting?.settings_key;
  const kind = options.kind || inferKind(settingsKey, options.formula || {});
  if (kind === "commission" || settingsKey === "commission_calc_formula") {
    const queryFields = (options.queryKeys || [])
      .map((key) => fieldsFromQueryKey(key))
      .flat();
    const allQueryFields = QUERY_CATALOG.flatMap((q) => q.fields);
    return collectUniqueFields([
      COMMISSION_PARAM_FIELDS,
      queryFields.length ? queryFields : allQueryFields,
    ]);
  }

  if (kind === "job") {
    return collectUniqueFields([DASHBOARD_FIELDS, COMMISSION_PARAM_FIELDS]);
  }

  return DEFAULT_FIELD_CATALOGS[settingsKey] || TARGET_FIELDS;
}

export function getFieldsForOutput(setting, options = {}) {
  const kind = options.kind || inferKind(setting?.settings_key, options.formula || {});
  if (kind !== "commission") {
    return getFormulaFieldCatalog(setting, { ...options, kind });
  }

  const defs = getOutputDefinitions(setting?.settings_key, kind);
  const outputDef = defs.find((item) => item.key === options.outputKey);
  const queryKeys = [];
  if (outputDef?.queryMetric) {
    const bound = options.formula?.queries?.[outputDef.queryMetric];
    if (bound) queryKeys.push(bound);
  }
  if (!queryKeys.length) {
    queryKeys.push(...Object.values(options.formula?.queries || {}).filter(Boolean));
  }

  const otherOutputs = defs
    .filter((item) => item.key !== options.outputKey)
    .map((item) => ({
      key: item.key,
      fa: item.fa,
      category: "خروجی‌های دیگر",
    }));

  const tableFields = Object.keys(options.formula?.tables || {}).map((key) => ({
    key: `TABLES.${key}`,
    fa: `جدول ${options.formula.tables[key]?.title || key}`,
    category: "جداول باند",
  }));

  return collectUniqueFields([
    queryKeys.flatMap(fieldsFromQueryKey),
    COMMISSION_PARAM_FIELDS,
    otherOutputs,
    tableFields,
  ]);
}

function inferKind(settingsKey, raw = {}) {
  if (raw.kind) return raw.kind;
  if (settingsKey === "dashboard_formula") return "dashboard";
  if (settingsKey === "commission_calc_formula") return "commission";
  return "suggestion";
}

function getOutputDefinitions(settingsKey = "", kind = "") {
  const resolved = kind || inferKind(settingsKey, {});
  if (resolved === "dashboard") return DASHBOARD_OUTPUT_KEYS;
  if (resolved === "commission") return COMMISSION_OUTPUT_KEYS;
  if (resolved === "job") return JOB_OUTPUT_KEYS;
  return OUTPUT_KEYS;
}

function defaultCommissionShape() {
  const queries = {};
  const tables = {};
  COMMISSION_COMPONENT_QUERIES.forEach((row) => {
    queries[row.tableKey] = row.queryKeys[0];
    tables[row.tableKey] = {
      key: row.tableKey,
      title: row.fa,
      query_key: row.queryKeys[0],
      bands: [],
    };
  });
  return {
    queries,
    tables,
    entry_condition: {
      min_percent: 70,
      applies_to: ["active_target", "return_pct", "claims"],
    },
    rial_cap_trigger_percent: 2.2,
    rial_cap_percent: 2,
  };
}

function queryForOutput(outputDef, queries = {}) {
  if (!outputDef?.queryMetric) return "";
  return queries[outputDef.queryMetric] || "";
}

function outputDefForQueryMetric(metric) {
  return COMMISSION_OUTPUT_KEYS.find((item) => item.queryMetric === metric) || null;
}

function queriesForKind(kind) {
  if (kind === "commission") return QUERY_CATALOG;
  return [];
}

function fieldsFromQueryKey(queryKey) {
  const q = QUERY_CATALOG.find((item) => item.key === queryKey);
  return q?.fields || [];
}

function collectUniqueFields(lists) {
  const seen = new Set();
  const out = [];
  lists.flat().forEach((field) => {
    if (!field?.key || seen.has(field.key)) return;
    seen.add(field.key);
    out.push(field);
  });
  return out;
}

export function createEmptyFormula(existingKeys = [], settingsKey = "", kind = "") {
  let index = existingKeys.length + 1;
  let key = `formula_${index}`;
  while (existingKeys.includes(key)) {
    index += 1;
    key = `formula_${index}`;
  }

  const resolvedKind = kind || inferKind(settingsKey, {});
  const outputDefs = getOutputDefinitions(settingsKey, resolvedKind);
  const outputs = {};
  const expressions = {};

  outputDefs.forEach((def) => {
    outputs[def.key] = def.defaultFormula || "";
    expressions[def.key] = parseFormulaString(def.defaultFormula || "");
  });

  const commissionShape =
    resolvedKind === "commission" ? defaultCommissionShape() : { queries: {}, tables: {}, entry_condition: {} };

  return {
    key,
    title: "",
    description: "",
    fa_description: "",
    kind: resolvedKind,
    formula: outputs[outputDefs[0]?.key] || "",
    expression: expressions[outputDefs[0]?.key] || [],
    outputs,
    expressions,
    formula_type: key,
    months_lookback: 3,
    metric_unit: "carton",
    queries: commissionShape.queries,
    tables: commissionShape.tables,
    entry_condition: commissionShape.entry_condition,
    query_key: "",
    rial_cap_trigger_percent: commissionShape.rial_cap_trigger_percent ?? 2.2,
    rial_cap_percent: commissionShape.rial_cap_percent ?? 2,
    fields: {
      rial_cap_trigger_percent: commissionShape.rial_cap_trigger_percent ?? 2.2,
      rial_cap_percent: commissionShape.rial_cap_percent ?? 2,
    },
  };
}

export function ensureUniqueFormulaKey(desiredKey, existingKeys = [], currentKey = null) {
  const base = slugifyKey(desiredKey) || "formula";
  if (!existingKeys.includes(base) || base === currentKey) return base;

  let i = 2;
  while (existingKeys.includes(`${base}_${i}`)) i += 1;
  return `${base}_${i}`;
}

export {
  OPERATORS,
  COMPARISONS,
  FUNCTIONS,
  METRIC_UNITS,
  OUTPUT_KEYS,
  DASHBOARD_OUTPUT_KEYS,
  COMMISSION_OUTPUT_KEYS,
  JOB_OUTPUT_KEYS,
  FORMULA_KINDS,
  QUERY_CATALOG,
  COMMISSION_PARAM_FIELDS,
  COMMISSION_COMPONENT_QUERIES,
  expressionToString,
  parseFormulaString,
  slugifyKey,
  inferKind,
  getOutputDefinitions,
  queriesForKind,
  fieldsFromQueryKey,
  collectUniqueFields,
  defaultCommissionShape,
  queryForOutput,
  outputDefForQueryMetric,
};
